const TravelMap = () => {

    return (
        <div className="m-20 h-screen md:mx-5">
            <iframe src="https://www.google.com/maps/d/u/0/embed?mid=1z47Jfc0_WqSRWSJNbsKzdSR1JdUTnlg&ehbc=2E312F&noprof=1" 
                className="w-full h-[600px]" />
        </div>
    );
};

export default TravelMap;